import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

export const permissionGuard = (requiredPermission: string): CanActivateFn => {
  return () => {
    const perms = inject(PermissionsService);
    const router = inject(Router);
    if (perms.has(requiredPermission)) return true;
    router.navigate(['/unauthorized']);
    return false;
  };
};
